var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 491,
    viewBox: "0 0 1440 491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_116_6118)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 773.5,
    cy: 663.5,
    rx: 1068.5,
    ry: 449.5,
    fill: "#7100FD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 773.5,
    cy: 774.5,
    rx: 1068.5,
    ry: 449.5,
    fill: "#B53087"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 773.5,
    cy: 892.5,
    rx: 1068.5,
    ry: 449.5,
    fill: "#F96011"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_116_6118",
    x: -509,
    y: 0,
    width: 2565,
    height: 1556,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 107,
    result: "effect1_foregroundBlur_116_6118"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterEllipse);
export default __webpack_public_path__ + "static/media/footer-ellipse.a28954ed72904d88f4f1d5d512e1b257.svg";
export { ForwardRef as ReactComponent };